module.exports = __webpack_public_path__ + "media/common/interview-feature2-fe9bf084.svg";